import React from 'react';
import { connect } from 'react-redux';
import Loading from '../../../components/Common/Loading';
import Module from '../../../components/Exchange/Mine/Module';
import common from '../../../common/common';
import { categoryMap } from '../../../common/category';
import {Commun} from "../../../utils/axios";

class MyExchange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            // 我的兑换列表
            orderList: [
                {
                    category: categoryMap['avatar'], // 头像框
                    data: []
                },
                {
                    category: categoryMap['subtitles'],  // 弹幕框
                    data: []
                },
                {
                    category: categoryMap['video'], // 视频框
                    data: []
                },
                {
                    category: categoryMap['gift'], // 实物
                    data: []
                }
            ]
        }
    }

    componentDidMount() {
        this.getOrderList(); // 获取我的兑换列表(我的兑换和机构无关，展示的是购买的所有机构下的商品列表）
    }

    getOrderList = () => {
        this.setState({
            loading: true
        });

        Commun.get(`${common.starApiPrefix}/user/order-list`).then(res => {
            const orderList = this.regenerateOrderList(res || []);
            this.setState({
                orderList
            })
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 重新生成列表
    regenerateOrderList = (list) => {
        const orderList = [
            {
                category: categoryMap['avatar'], // 头像框
                data: []
            },
            {
                category: categoryMap['subtitles'],  // 弹幕框
                data: []
            },
            {
                category: categoryMap['video'], // 视频框
                data: []
            },
            {
                category: categoryMap['gift'], // 实物
                data: []
            }
        ];
        for (let item of list) {
            const index = orderList.findIndex(categoryItem => categoryItem.category === item.category);
            if (index === -1) {
                orderList[orderList.length] = {
                    category: item.category,
                    data: [item]
                };
            } else {
                orderList[index]['data'].push(item);
            }
        }
        return orderList;
    };

    // Module数据改变
    onDataChange = (index, data) => {
        const orderList = [...this.state.orderList];
        orderList.splice(index, 1, {
            ...orderList[index],
            data
        });
        this.setState({
            orderList
        })
    };


    render() {
        const { loading, orderList } = this.state;

        return (
            <React.Fragment>
                {
                    loading ? <Loading/> :
                    orderList.map((item, index) =>
                        <Module
                            key={index}
                            category={item.category}
                            data={item.data}
                            getList={this.getOrderList}
                            onDataChange={(data) => this.onDataChange(index, data)}
                        />
                    )
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    ...state.exchange
});

export default connect(
    mapStateToProps
)(MyExchange);